webpackJsonp([604904075748],{

/***/ 779:
/***/ (function(module, exports) {

	module.exports = {"data":{"contributionsJson":{"name":"readmylips from johan soederbe","www_url":"http://www.atmo.se","thema":"blind love","issue_month":"September","issue_year":2005,"issue_date":200509,"artist":"johan soederbe","location":"Sweden","email":"","id":"contribution_125","media_type":"moving_image","position_in_section":1,"media_uri":"media/2005/September/moving_image/bushblair_endlesslove.mov","media_th_uri":"","still_image_count":9,"moving_image_count":1,"textz_count":1,"soundz_count":0}},"pathContext":{"id":"contribution_125"}}

/***/ })

});


// WEBPACK FOOTER //
// path---issue-200509-moving-image-1-9659d31fb3704b61a096.js